/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Blood pressure category selected by user. Not persisted, echoed back in response.
 * @export
 * @enum {string}
 */

export enum BloodPressureCategory {
  NORMAL = 'NORMAL',
  PRE_HYPERTENSIVE = 'PRE_HYPERTENSIVE',
  HYPERTENSIVE = 'HYPERTENSIVE',
}
